import { useContext, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import BlockTemplate from 'app/components/Blocks/BlockTemplate';
import ConfigContext from 'app/common/ConfigContext';
import { getDisplayedLeagueName } from 'app/config/customerSpecific.config.helper';
import { localizeTournamentName } from 'app/i18n/utils';

import Bracket from './Bracket';
import style from './style.module.scss';

interface Props {
  bracket: TournamentBracket;
}

const BracketsBlock: FC<Props> = ({ bracket }) => {
  const { t } = useTranslation();
  const { customer } = useContext(ConfigContext);
  const leagueName = getDisplayedLeagueName(bracket.league_name, bracket.league_id, customer);

  return (
    <BlockTemplate
      title={[leagueName, bracket.serie_full_name].filter(Boolean).join(' ')}
      subtitle={localizeTournamentName(t, bracket.name)}
      containerClassname={style.bracketBlockContainer}
      subtitleClassName={style.bracketBlockSubtitle}
      titleClassName={style.bracketBlockTitle}
      testId="brackets-block"
    >
      <Bracket bracket={bracket} />
    </BlockTemplate>
  );
};

BracketsBlock.displayName = 'BracketsBlock';

export default BracketsBlock;
